import type { JSX } from "react";
import { Skeleton } from "@/components/skeleton.tsx";

export const LivancePayCardGroupSkeleton = (): JSX.Element => {
  return (
    <>
      <div className="grid gap-4 grid-cols-2">
        <Skeleton
          aria-label="Pagamentos realizados carregando"
          className="h-[7.125rem] rounded-xl"
        />
        <Skeleton
          aria-label="Valor em aberto carregando"
          className="h-[7.125rem] rounded-xl"
        />
        <Skeleton
          aria-label="Valor total pago carregando"
          className="h-[5.5625rem] rounded-xl col-span-2 lg:col-span-1"
        />
      </div>
      <Skeleton
        aria-label="Período dos dados do Livande Pay carregando"
        className="rounded-xl w-[55%] h-[1.25rem]"
      />
    </>
  );
};
